function initializeMarquee(container) {
  const marqueeText = container.querySelector(".marquee-text");
  if (marqueeText) {
    let textWidth = marqueeText.getBoundingClientRect().width;
    let textHeight = marqueeText.offsetHeight;
    let position = -textWidth;
    let cloned = false; // Moved inside initializeMarquee to reset every call

    container.style.height = textHeight + 'px';

    // Clone the marquee text only once
    if (!cloned) {
      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = marqueeText.cloneNode(true);
        marqueeTextClone.style.left = (textWidth * i + position) + "px";
        container.appendChild(marqueeTextClone);
      }
      cloned = true; // Set flag to true after cloning
    }

    function marquee() {
      position -= 2;
      if (position <= -textWidth) {
        position += textWidth;
      }
      marqueeText.style.left = position + "px";

      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = container.children[i];
        marqueeTextClone.style.left = (position + textWidth * i) + "px";
      }
    }

    setInterval(marquee, 50);

    window.addEventListener('resize', function() {
      textWidth = marqueeText.getBoundingClientRect().width;
      textHeight = marqueeText.offsetHeight;
      position = -textWidth;
      container.style.height = textHeight + 'px';
      marqueeText.style.left = position + "px";
      for (let i = 1; i <= 20; i++) {
        const marqueeTextClone = container.children[i];
        marqueeTextClone.style.left = (position + textWidth * i) + "px";
      }
    });
  }
}

window.onload = function() {
  const marqueeContainers = document.querySelectorAll(".marquee-container");
  marqueeContainers.forEach(initializeMarquee);
};

// Ensure marqueeTimeoutId is not redeclared
if (typeof marqueeTimeoutId === 'undefined') {
  var marqueeTimeoutId; // Var for hoisting to global scope
}

document.addEventListener("shopify:section:load", function(event) {
  if (marqueeTimeoutId) {
    clearTimeout(marqueeTimeoutId);
  }
  marqueeTimeoutId = setTimeout(function() {
    if (document.querySelector(`#shopify-section-${event.detail.sectionId} .marquee-container`)) {
      initializeMarquee(document.querySelector(`#shopify-section-${event.detail.sectionId} .marquee-container`));
    }
  }, 300);
});
